/**
 * Single browser→Explorer-server off-chain request path.
 */
function sendExplorerPeerRequest(app, requestName) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = options.data,
    callback = options.callback,
    peer = options.peer;
  var peerPublicKey = peer === null || peer === void 0 ? void 0 : peer.publicKey;
  return app.network.sendRequestAsTransaction(requestName, data, callback, peerPublicKey);
}
module.exports = {
  sendExplorerPeerRequest: sendExplorerPeerRequest
};